import { fromJS } from 'immutable';
import { GET_LOG, SET_LOG } from './constants';

export const getLog = (gameId) => ({
  type: GET_LOG,
  payload: fromJS({ gameId }),
});

/** The log as the server sent it: plain entries, which describeEntry reads as they are. */
export const setLog = (gameId, entries) => ({
  type: SET_LOG,
  payload: { gameId, entries },
});
